import {PosTerminalDrawerTxnContainerModel} from '../../../../../../models/aggregates/erp/pos/pos-terminal-drawer-txn-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class PosTerminalDrawerTxnService extends BaseApiTemplateService<PosTerminalDrawerTxnContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos-terminal-drawer-txns/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos-terminal-drawer-txns/backoffice-ep';
    this.httpClient = http;
  }
}
